<form [formGroup]="helpForm">
    <div class="topsearchabr">
        <div>
            <span style="font-weight: 600;">OG Help</span>
            <span>{{contentTitle}}</span>
        </div>
        <div class="searchbar">
            <input class="form-control" type="input" formControlName="searchText" placeholder="Search">
            <button (click)="searchContent()" class="searchBtn">GO</button>
        </div>
    </div>
    <div class="helpwraper">
        <div class="helpleftbar">
            <nav class="navside">
                <ul>
                    <li class="sub" *ngFor="let mainmenu of mainMenus">
                        <input type="checkbox" />
                        <a href="JavaScript:void(0);">{{mainmenu.name}}</a>
                        <ul class="submenu">
                            <li *ngFor="let submenu of loadSubMenu(mainmenu.id)">
                                <a href="JavaScript:void(0);" (click)="loadSubContent(submenu)">{{submenu.name}}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="hlepcontents">
            <div *ngIf="!helpForm.value.searchOn" [innerHtml]="helpContents" id="divcontent"></div>
            <div *ngIf="helpForm.value.searchOn">
                <h3>Filter Result For "{{displaySearchTxt}}"</h3>
                <div *ngIf="helpForm.value.searchData.length>0">
                    <div *ngFor="let item of helpForm.value.searchData" class="searchItem">
                        <div>
                            {{item.name}} have same content
                        </div>
                        <div>
                            <span style="color:rgb(38 159 38);cursor: pointer;font-weight: bold;"
                                (click)="loadSubContent(item)">
                                Click here for more details
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="helpForm.value.searchData.length==0">
                    Information not found
                </div>
            </div>
        </div>
    </div>
</form>